<app-common-modal-form
  header="Upload Files"
  icon="ic-upload-file-20"
  confirmText="Save"
  closeText="Cancel"
  footerClass="d-flex justify-content-end flex-row-reverse"
  [isInvalid]="!uploadedFiles.length"
  (confirm)="confirm()"
  (close)="close()"
>
  <div class="body-container">
    @if (errorMessage) {
      <div class="w-100 mt-2">
        <app-disclaimer
          icon="ic-cancel-circle-20"
          color="red"
        >
          {{ errorMessage }}
        </app-disclaimer>
      </div>
    } @else if (!uploadedFiles.length && infoMessageHtml) {
      <div class="w-100 mt-2">
        <app-disclaimer
          icon="ic-alert-triangle-20"
          color="orange"
          [content]="infoMessageHtml"
        />
      </div>
    }

    @if (uploadedFiles.length) {
      <div class="files-container">
        @for (file of uploadedFiles; track $index) {
          <app-file-label
            [showControlsOnlyOnHover]="false"
            [hideDownloadBtn]="true"
            (deleteFile)="deleteFile($index)"
          >
            {{ file.name }}
          </app-file-label>
        }
      </div>
    } @else {
      <app-file-upload
        [multiple]="multiple"
        [acceptedFormatsList]="config.acceptedFormatsList"
        (change)="onFilesLoaded($event)"
      />
    }

    <div class="note mb-2" [hidden]="uploadedFiles.length">{{ uploadNotification }}</div>
  </div>
</app-common-modal-form>
